import { render, staticRenderFns } from "./SupportMetrics.vue?vue&type=template&id=83783650&"
import script from "./SupportMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./SupportMetrics.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports